import { useLocalStorage } from 'usehooks-ts'

type AnalyticsOptions = {
  isGoogleAnalyticsEnabled: boolean
}

export type AnalyticsAcceptanceOptions = {
  version: number
  analytics: AnalyticsOptions
}

export const useAnalyticsAcceptance = () => {
  // Bump this number to invalidate the previous Analytics acceptance
  const lastVersion = 1

  const defaultAnalyticsOptions: AnalyticsAcceptanceOptions = {
    version: 0,
    analytics: {
      isGoogleAnalyticsEnabled: true,
    },
  }

  const analyticsAcceptanceKey = 'analytics-acceptance'
  const [analyticsAcceptance, setAnalyticsAcceptance] = useLocalStorage<AnalyticsAcceptanceOptions>(
    analyticsAcceptanceKey,
    defaultAnalyticsOptions
  )

  return {
    isNewAnalyticsVersionAvailable: analyticsAcceptance.version < lastVersion,
    analytics: analyticsAcceptance.analytics,
    setAnalytics: (analytics: AnalyticsOptions) => setAnalyticsAcceptance({ version: lastVersion, analytics }),
    invalidateAnalyticsConsent: () => setAnalyticsAcceptance((prev) => ({ ...prev, version: 0 })),
  }
}
